import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import UserMenu from './UserMenu';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isLoggedIn, user, refreshAuthState } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // Refresh auth state when component mounts or location changes
  useEffect(() => {
    refreshAuthState();
  }, [refreshAuthState, location]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    closeMenu();
    
    if (location.pathname !== '/' && location.pathname !== '/home') {
      navigate('/');
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  const handleGetApp = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    closeMenu();
    
    if (location.pathname !== '/' && location.pathname !== '/home') {
      navigate('/');
      setTimeout(() => {
        const downloadSection = document.getElementById('download');
        if (downloadSection) {
          downloadSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      const downloadSection = document.getElementById('download');
      if (downloadSection) {
        downloadSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  // Debug logging
  useEffect(() => {
    console.log('🔍 Navbar auth state:', { isLoggedIn, user });
  }, [isLoggedIn, user]);

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand" onClick={closeMenu}>
        <img src="/assets/logo2.webp" alt="Oliveeb" className="navbar-logo" style={{ height: '50px' }} />
      </Link>
      <button 
        className="navbar-toggle" 
        onClick={toggleMenu} 
        aria-label="Open menu" 
        aria-expanded={isMenuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div className={`navbar-nav ${isMenuOpen ? 'is-open' : ''}`} id="primaryNav">
        <Link to="/" className="nav-link" onClick={closeMenu}>Home</Link>
        <a href="#services" className="nav-link" onClick={(e) => handleNavClick(e, 'services')}>Services</a>
        <a href="#how-it-works" className="nav-link" onClick={(e) => handleNavClick(e, 'how-it-works')}>How It Works</a>
        <Link to="/donate" className="nav-link" onClick={closeMenu}>Donate</Link>
        <Link to="/about" className="nav-link" onClick={closeMenu}>About Us</Link>
        <Link to="/faq" className="nav-link" onClick={closeMenu}>FAQ</Link>
        
        {!isLoggedIn ? (
          <>
            <Link to="/signin" className="nav-link auth-signin" onClick={closeMenu}>Sign In</Link>
            <Link to="/signup" className="nav-link auth-signup" onClick={closeMenu}>Sign Up</Link>
          </>
        ) : (
          <UserMenu />
        )}
        
        <a href="#download" className="nav-link cta" onClick={handleGetApp}>Get App</a>
      </div>
    </nav>
  );
};

export default Navbar;